export let ProductDetailsMainSlider: any = {
    items: 1,
    nav: false,
    dots:true,
    autoplay: false,
    slideSpeed: 300,
    loop: true
  }